import Login from '../component/common/Login';

export default function LoginPage() {
    return (
        <>
            <Login />
        </>
    );
}
